<template>
  <section v-show="isActive" class="tabs__accordion-section">
    <div :class="{ 'tabs__accordion-content--is-active': isActive }" class="tabs__accordion-content">
      <slot v-if="!lazy || hasBeenActive"></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    displayName: {
      type: String,
      default: ''
    },
    // Renders the content the first time the tab is opened, not with the page, for content that
    // fetches something costly when it is created. It is kept once rendered.
    lazy: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isActive: false,
    hasBeenActive: false
  }),
  watch: {
    selected(newVal) {
      this.isActive = newVal
    },
    isActive(newVal) {
      if (newVal) {
        this.hasBeenActive = true
      }
    }
  },
  mounted() {
    this.isActive = this.selected
  }
}
</script>
